import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
// libraries
import {AgmCoreModule} from '@agm/core';
import {TranslateModule} from '@ngx-translate/core';
import {TextMaskModule} from 'angular2-text-mask';
import {NgSelectModule} from '@ng-select/ng-select';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
// modules
import {ConsignmentRoutingModule} from './consignment-routing.module';
import {SharedModule} from '@modules/shared/shared.module';
import {MaterialModule} from '@modules/material/material.module';
// services
import {GoogleMapsService} from '@services/google-maps.service';
import {ShipmentService} from '@services/shipment.service';
import {UserService} from '@services/user.service';
import {AccountService} from '@services/account.service';
import {AdyenService} from '@services/adyen.service';
import {CreateConsignmentService} from '@modules/consignment/create-consignment.service';
//guards
import {SearchResultGuard} from '@modules/consignment/services/search-result.guard';
import {OrderSummaryGuard} from '@modules/consignment/services/order-summary.guard';
import {OrderCompleteGuard} from '@modules/consignment/services/order-complete.guard';
// container components
import {ConsignmentComponent} from '@modules/consignment/consignment.component';
import {SearchComponent} from '@modules/consignment/search/search.component';
import {OrderCompleteComponent} from '@modules/consignment/order-complete/order-complete.component';
import {OrderSummaryComponent} from '@modules/consignment/order-summary/order-summary.component';
import {SearchResultsComponent} from '@modules/consignment/search-results/search-results.component';
// presentational components
import {ConsignmentFormComponent} from '@modules/consignment/search/components/consignment-form/consignment-form.component';
import {PackageDetailsFormComponent} from '@modules/consignment/search/components/package-details-form/package-details-form.component';
import {ShippingDetailFormComponent} from '@modules/consignment/search/components/shipping-detail-form/shipping-detail-form.component';
import {PaymentMethodFormComponent} from '@modules/consignment/order-summary/components/payment-method-form/payment-method-form.component';
import {SearchSummaryComponent} from '@modules/consignment/components/search-summary/search-summary.component';
import {SearchResultCardComponent} from '@modules/consignment/search-results/components/search-result-card/search-result-card.component';
import {ShipmentSummaryComponent} from '@modules/consignment/components/shipment-summary/shipment-summary.component';
import {OrderShipmentsComponent} from '@modules/consignment/order-summary/components/order-shipments/order-shipments.component';
import {TotalPriceComponent} from '@modules/consignment/order-summary/components/total-price/total-price.component';
import {OrderCompleteCardComponent} from '@modules/consignment/order-complete/components/order-complete-card/order-complete-card.component';
import {SearchResultComponent} from '@modules/consignment/search-results/components/search-result/search-result.component';
import {
  SearchFailureHeaderComponent
} from '@modules/consignment/search-results/components/search-failure-header/search-failure-header.component';
import {InsuranceComponent} from '@modules/consignment/order-summary/components/insurance/insurance.component';
import {
  OrderShipmentsSummaryComponent
} from '@modules/consignment/order-summary/components/order-shipments-summary/order-shipments-summary.component';
import {
  SearchResultCardFailureComponent
} from '@modules/consignment/search-results/components/search-result-card-failure/search-result-card-failure.component';
import {ProductsFormComponent} from '@modules/consignment/search/components/products-form/products-form.component';
import {PackageTemplatesService} from '@services/package-templates.service';
import {CustomsFormComponent} from '@modules/consignment/search/components/customs-form/customs-form.component';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MaterialModule,
    TextMaskModule,
    TranslateModule.forChild(),
    NgSelectModule,
    FontAwesomeModule,
    SharedModule,
    ConsignmentRoutingModule
  ],
  providers: [
    GoogleMapsService,
    ShipmentService,
    UserService,
    AccountService,
    AdyenService,
    CreateConsignmentService,
    PackageTemplatesService,
    SearchResultGuard,
    OrderSummaryGuard,
    OrderCompleteGuard,
  ],
  declarations: [
    ConsignmentComponent,
    ConsignmentFormComponent,
    PackageDetailsFormComponent,
    ShippingDetailFormComponent,
    ProductsFormComponent,
    CustomsFormComponent,
    PaymentMethodFormComponent,
    SearchComponent,
    SearchResultsComponent,
    OrderSummaryComponent,
    OrderCompleteComponent,
    SearchSummaryComponent,
    SearchResultCardComponent,
    ShipmentSummaryComponent,
    OrderShipmentsComponent,
    TotalPriceComponent,
    OrderCompleteCardComponent,
    SearchResultComponent,
    SearchFailureHeaderComponent,
    InsuranceComponent,
    OrderShipmentsSummaryComponent,
    SearchResultCardFailureComponent,
  ],
  exports: [
    ConsignmentComponent,
  ]
})

export class ConsignmentModule {
}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/consignment.module.ts